import React from "react";
import { Row, Col, Form } from "react-bootstrap";
import { useForm, FormProvider } from "react-hook-form";

import { HookFormInputGroup } from "components";
import {
	commaAndFloat2Normalizer,
	floatWithComma2Normalizer,
} from "validators";
import {
	conjunctValidators,
	dateValidation,
	maxDateNow,
	minDateYearAgo,
	onlyDate,
	required,
} from "validators/validation";

import { RowActions } from "./rowActions";

import styles from "../tables.module.scss";

export const EditableTableRow = ({
	row = { id: null, edit: true, columns: [] },
	onDeleteClick,
	onSaveClick,
	onHideEditRowClick,
	actionsClassName,
	inputFieldColSize = 12,
}) => {
	const formMethods = useForm();

	const {
		handleSubmit,
		register,
		reset,

		formState: { errors },
	} = formMethods;

	const wrapAction = async (action, params) => {
		if (action) await action(params);
		reset();
	};

	const getField = column => {
		let props = {
			name: column.name,
			register,
			defaultValue: column.value,
			errors,
			className: styles.column,
			colInput: inputFieldColSize,
			solveCaretIssue: true,
		};
		switch (column.type) {
			case "date":
				props = {
					...props,
					validator: conjunctValidators([
						required,
						dateValidation,
						maxDateNow,
						minDateYearAgo,
					]),
					normalize: onlyDate,
					placeholder: "MM/DD/YYYY",
					errorClassName: styles.errorStyles,
				};
				break;
			case "currency":
				props = {
					...props,
					validator: conjunctValidators([required]),
					normalize: commaAndFloat2Normalizer,
					normalizeOnBlur: floatWithComma2Normalizer,
					solveCaretIssue: commaAndFloat2Normalizer,
					defaultValue: commaAndFloat2Normalizer(column.value),
					placeholder: "0.00",
				};
				break;

			default:
				const err = { error: "Not supported" };
				throw err;
		}

		return <HookFormInputGroup {...props} />;
	};
	const getPrepend = column => {
		if (column.type === "currency")
			return <span className={styles.currency}>$</span>;
	};

	return (
		<FormProvider {...formMethods}>
			<Form
				onSubmit={handleSubmit(params =>
					wrapAction(onSaveClick, params),
				)}
				className={`${styles.row} ${styles.stickyRow}`}
				autoComplete="off"
			>
				<input {...register("id")} defaultValue={row.id} hidden />
				<Row className="m-0">
					{row.columns.map((column, i) => (
						<Col
							key={`col-${i}-${column.value}`}
							className="d-flex "
						>
							{getPrepend(column)}
							{getField(column)}
						</Col>
					))}
					<RowActions
						onDeleteClick={
							onDeleteClick &&
							(params => wrapAction(onDeleteClick, params))
						}
						onSaveClick={handleSubmit(params =>
							wrapAction(onSaveClick, params),
						)}
						onHideEditRowClick={
							onHideEditRowClick &&
							(() => {
								onHideEditRowClick();
							})
						}
						className={actionsClassName}
					/>
				</Row>
			</Form>
		</FormProvider>
	);
};
